// ============================================================
// MUI Palette Configuration
// ============================================================

import { tokens } from './tokens';

export const palette = {
  primary: { ...tokens.colors.primary },
  secondary: { ...tokens.colors.secondary },
  success: { ...tokens.colors.success },
  warning: { ...tokens.colors.warning },
  error: { ...tokens.colors.error },
  info: { ...tokens.colors.info },
  grey: { ...tokens.colors.grey },
  text: {
    primary: tokens.colors.text.primary,
    secondary: tokens.colors.text.secondary,
    disabled: tokens.colors.text.disabled,
  },
  background: {
    default: tokens.colors.background,
    paper: tokens.colors.card,
  },
  divider: tokens.colors.border,
  action: {
    hover: 'rgba(37, 99, 235, 0.04)',
    selected: 'rgba(37, 99, 235, 0.08)',
    focus: 'rgba(37, 99, 235, 0.12)',
  },
};
